import { Action } from "redux";
import { IAddCustomerInformationRequest, ICustomerInformation, IShippingInformation, IUpdateShippingInformationRequest, IOrderSummary } from "@montana/models/generated/cms.interface";

export enum CheckoutActionTypes {
    SET_CUSTOMER_INFORMATION = '@@checkout/SET_CUSTOMER_INFORMATION',
    SET_CUSTOMER_INFORMATION_SUCCESS = '@@checkout/SET_CUSTOMER_INFORMATION_SUCCESS',
    LOAD_CUSTOMER_INFORMATION = '@@checkout/LOAD_CUSTOMER_INFORMATION',
    LOAD_CUSTOMER_INFORMATION_SUCCESS = '@@checkout/LOAD_CUSTOMER_INFORMATION_SUCCESS',
    LOAD_SHIPPING_INFORMATION = '@@checkout/LOAD_SHIPPING_INFORMATION',
    LOAD_SHIPPING_INFORMATION_SUCCESS = '@@checkout/LOAD_SHIPPING_INFORMATION_SUCCESS',
    SET_SHIPPING_INFORMATION = '@@checkout/SET_SHIPPING_INFORMATION',
    SET_SHIPPING_INFORMATION_SUCCESS = '@@checkout/SET_SHIPPING_INFORMATION_SUCCESS',
    LOAD_ORDER_INFORMATION_SUCCESS = '@@checkout/LOAD_ORDER_INFORMATION_SUCCESS',
}

// Customer Information
export interface ISetCustomerInformation extends Action<CheckoutActionTypes.SET_CUSTOMER_INFORMATION> {
    customerInformation: IAddCustomerInformationRequest;
}

export const setCustomerInformation = (customerInformation: IAddCustomerInformationRequest): ISetCustomerInformation => ({
    type: CheckoutActionTypes.SET_CUSTOMER_INFORMATION,
    customerInformation
});

interface ISetCustomerInformationSuccess extends Action<CheckoutActionTypes.SET_CUSTOMER_INFORMATION_SUCCESS> {
    customerInformation: IAddCustomerInformationRequest;
}

export const setCustomerInformationSuccess = (customerInformation: IAddCustomerInformationRequest): ISetCustomerInformationSuccess => ({
    type: CheckoutActionTypes.SET_CUSTOMER_INFORMATION_SUCCESS,
    customerInformation
});

type ILoadCustomerInformation = Action<CheckoutActionTypes.LOAD_CUSTOMER_INFORMATION>;

export const loadCustomerInformation = (): ILoadCustomerInformation => ({
    type: CheckoutActionTypes.LOAD_CUSTOMER_INFORMATION
});

interface ILoadCustomerInformationSuccess extends Action<CheckoutActionTypes.LOAD_CUSTOMER_INFORMATION_SUCCESS> {
    customerInformation: ICustomerInformation;
}

export const loadCustomerInformationSuccess = (customerInformation: ICustomerInformation): ILoadCustomerInformationSuccess => ({
    type: CheckoutActionTypes.LOAD_CUSTOMER_INFORMATION_SUCCESS,
    customerInformation
});

// Shipping Information
type ILoadShippingInformation = Action<CheckoutActionTypes.LOAD_SHIPPING_INFORMATION>;

export const loadShippingInformation = (): ILoadShippingInformation => ({
    type: CheckoutActionTypes.LOAD_SHIPPING_INFORMATION
});

interface ILoadShippingInformationSuccess extends Action<CheckoutActionTypes.LOAD_SHIPPING_INFORMATION_SUCCESS> {
    shippingInformation: IShippingInformation[];
}

export const loadShippingInformationSuccess = (shippingInformation: IShippingInformation[]): ILoadShippingInformationSuccess => ({
    type: CheckoutActionTypes.LOAD_SHIPPING_INFORMATION_SUCCESS,
    shippingInformation
});

export interface ISetShippingInformation extends Action<CheckoutActionTypes.SET_SHIPPING_INFORMATION> {
    shippingInformation: IUpdateShippingInformationRequest;
    finalize: boolean;
}

export const setShippingInformation = (shippingInformation: IUpdateShippingInformationRequest, finalize = false): ISetShippingInformation => ({
    type: CheckoutActionTypes.SET_SHIPPING_INFORMATION,
    shippingInformation: shippingInformation,
    finalize,
});

type ISetShippingInformationSuccess = Action<CheckoutActionTypes.SET_SHIPPING_INFORMATION_SUCCESS>;

export const setShippingInformationSuccess = (): ISetShippingInformationSuccess => ({
    type: CheckoutActionTypes.SET_SHIPPING_INFORMATION_SUCCESS
});

export interface ILoadOrderInformationSuccess extends Action<CheckoutActionTypes.LOAD_ORDER_INFORMATION_SUCCESS> {
    orderInformation: IOrderSummary;
}

export const loadOrderInformationSuccess = (orderInformation: IOrderSummary): ILoadOrderInformationSuccess => ({
    type: CheckoutActionTypes.LOAD_ORDER_INFORMATION_SUCCESS,
    orderInformation,
});

export type ICheckoutAction =
    ISetCustomerInformation
    | ISetCustomerInformationSuccess
    | ILoadCustomerInformation
    | ILoadCustomerInformationSuccess
    | ILoadShippingInformation
    | ILoadShippingInformationSuccess
    | ISetShippingInformation
    | ISetShippingInformationSuccess
    | ILoadOrderInformationSuccess;
